import { render, staticRenderFns } from "./LayoutBreadcrumb.vue?vue&type=template&id=4cef0408&scoped=true"
import script from "./LayoutBreadcrumb.vue?vue&type=script&lang=js"
export * from "./LayoutBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./LayoutBreadcrumb.vue?vue&type=style&index=0&id=4cef0408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef0408",
  null
  
)

export default component.exports